// Infinite Illusion search results page: client-side filter-chip toggling
// and a plain sort <select> that navigates with an updated sort_by param.
// Both are full-reload-free/full-reload interactions respectively, matching
// this theme's established tag-filter convention (sections/ii-filter-tabs.liquid)
// rather than reaching into Pitch's private facets.js component.

function initSearchFilterChips() {
  const rfilters = document.querySelector('.ii-rfilters');
  const grid = document.getElementById('ii-search-grid');
  if (!rfilters || !grid) return;

  const chips = Array.from(rfilters.querySelectorAll('[data-ii-filter]'));
  const cards = Array.from(grid.querySelectorAll('.ii-result-card'));

  rfilters.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-ii-filter]');
    if (!chip) return;

    chips.forEach((c) => c.classList.remove('ii-filter-tab--active'));
    chip.classList.add('ii-filter-tab--active');

    const filter = chip.dataset.iiFilter;

    cards.forEach((card) => {
      let visible = true;

      if (filter === 'in-stock') {
        visible = card.dataset.iiAvailable === 'true';
      } else if (filter !== 'all') {
        const tags = (card.dataset.iiTags || '').split(',');
        visible = tags.includes(filter);
      }

      card.classList.toggle('ii-result-card--hidden', !visible);
    });
  });
}

function initSearchSort() {
  const select = document.querySelector('.ii-sort-select');
  if (!select) return;

  const url = new URL(window.location.href);
  const currentSort = url.searchParams.get('sort_by');
  if (currentSort) select.value = currentSort;

  select.addEventListener('change', () => {
    const target = new URL(window.location.href);
    target.searchParams.set('sort_by', select.value);
    window.location.href = target.toString();
  });
}

initSearchFilterChips();
initSearchSort();
